export default "__VITE_ASSET__Sn77r28k__"